import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Form, FormInput, FormButton } from '../../../Common';
import { authService } from '../../../../services';
import { toast } from 'react-toastify';
import './AddUserForm.css';

interface AddUserFormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
}

interface AddUserFormData {
  fullName: string;
  email: string;
}

const AddUserForm: React.FC<AddUserFormProps> = ({ onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: AddUserFormData) => {
    try {
      setLoading(true);
      
      const response = await authService.addAdmin({ 
        fullName: data.fullName.trim(), 
        email: data.email.trim() 
      });
      
      console.log('✅ Create admin response:', response);
      
      toast.success('Invitation sent successfully');
      
      // Notify parent
      if (onSuccess) {
        onSuccess();
      }
    } catch (error: any) {
      console.error('Failed to add user:', error);
      toast.error(error?.response?.data?.message || 'Failed to send invitation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form<AddUserFormData>
      onSubmit={handleSubmit}
      defaultValues={{ fullName: '', email: '' }}
      resetOnSubmit={false}
    >
      {/* Form Fields */}
      <Box className="add-user-form-fields">
        <FormInput
          name="fullName"
          label="Name"
          placeholder="Placeholder"
          disabled={loading}
          required
        />
        <FormInput
          name="email"
          label="Email address"
          placeholder="Placeholder"
          type="email"
          disabled={loading}
          required
        />
      </Box>

      {/* Action Buttons */}
      <Box className="add-user-form-actions">
        <FormButton
          type="submit"
          primary
          disabled={loading}
          size="full"
        >
          {loading ? 'Sending...' : 'Send invitation'}
        </FormButton>
        <FormButton
          type="button"
          primary={false}
          bordered={false}
          onClick={onCancel}
          size="full"
          disabled={loading}
        >
          Cancel
        </FormButton>
      </Box>
    </Form>
  );
};

export default AddUserForm;

